import { render, staticRenderFns } from "./CreateMetier.vue?vue&type=template&id=3b0ec792&"
import script from "./CreateMetier.vue?vue&type=script&lang=js&"
export * from "./CreateMetier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports